import { render, staticRenderFns } from "./PasswordConfirmationActivationModal.vue?vue&type=template&id=bcdb28ee&scoped=true"
import script from "./PasswordConfirmationActivationModal.vue?vue&type=script&lang=js"
export * from "./PasswordConfirmationActivationModal.vue?vue&type=script&lang=js"
import style0 from "./PasswordConfirmationActivationModal.vue?vue&type=style&index=0&id=bcdb28ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcdb28ee",
  null
  
)

export default component.exports